<template>
    <v-text-field v-bind="innerAttrs" v-on="innerListeners" :error="error" :error-messages="errorMessages"></v-text-field>
</template>

<script>
export default {
    name: 'v-float-field',
    components: {},
    props: {
        value: Number,
        error: Boolean,
        errorMessages:String,
    },
    data: () => ({
        valueAsString: '',
        valueAsFloat: null,
        updateSuspended: false,
        valueIsDirty: false,
    }),
    mounted() {
        this.valueAsString = this.floatToString(this.value);
        this.valueAsFloat = this.stringToFloat(this.valueAsString);
    },
    computed: {
        innerAttrs() {
            return Object.assign({}, this.$attrs, {
                value: this.valueAsString,
            });
        },
        innerListeners() {
            return Object.assign({}, this.$listeners, {
                focus: this.onFocus,
                blur: this.onBlur,
                input: this.onInput,
            });
        },
    },
    watch: {
        value() {
            if (!this.updateSuspended) {
                this.valueAsString = this.floatToString(this.value);
                this.valueAsFloat = this.stringToFloat(this.valueAsString);
            }
        },
    },
    methods: {
        floatToString(float) {
            let string = null;
            if (typeof float == 'number') {
                string = float.toLocaleString('nl-NL', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
            return string;
        },
        stringToFloat(string) {
            let float = null;
            if (typeof string == 'string') {
                string = string.replace(/\./g, ',');
                string = string.replace(/[^0-9,]/g, '');
                string = string.replace(/,([0-9]{1,2})$/, '.$1');
                string = string.replace(/,/g, '');
                float = parseFloat(string);
                if (isNaN(float)) {
                    float = null;
                }
            }
            return float;
        },
        onFocus(payload) {
            this.updateSuspended = true;
            this.$emit('focus', payload);
        },
        onBlur(payload) {
            this.updateSuspended = false;
            this.$emit('blur', payload);
            if (this.valueIsDirty) {
                this.$emit('input', this.valueAsFloat);
            }
        },
        onInput(newValue) {
            this.valueAsFloat = this.stringToFloat(newValue);
            if (this.updateSuspended) {
                this.valueIsDirty = true;
            } else {
                this.$emit('input', this.valueAsFloat);
            }
        },
    },
};
</script>
